// Account Analytics section — FE-034 / spec §7.0.5.

import {
  DashboardCard,
  DashboardEmptyState,
  DashboardErrorState,
  DashboardLoadingState,
  useClientAnalyticsQuery,
  useCommonFilters,
  useDashboardDateRange,
} from "@/features/dashboard";

import { AccountKpiCards } from "./AccountKpiCards";


export const ACCOUNT_ANALYTICS_SECTION = "client-analytics" as const;


export function AccountAnalyticsSection() {
  const filters = useCommonFilters();
  const dateRange = useDashboardDateRange();
  const query = useClientAnalyticsQuery(filters);

  return (
    <DashboardCard
      section={ACCOUNT_ANALYTICS_SECTION}
      title="Account analytics"
      subtitle="Health of every active Account in your brokerage."
    >
      {query.isLoading ? (
        <DashboardLoadingState variant="card" />
      ) : query.isError ? (
        <DashboardErrorState
          title="Couldn't load Account analytics"
          retry={() => query.refetch()}
        />
      ) : query.data && query.data.total_clients > 0 ? (
        <AccountKpiCards data={query.data} dateRange={dateRange} />
      ) : (
        <DashboardEmptyState
          title="No active Accounts yet"
          description="Once Accounts are created, the KPI cards summarise their health here."
        />
      )}
    </DashboardCard>
  );
}
